import React from "react";
import {
  Description as DocumentIcon,
  Handshake as HandshakeIcon,
  QuestionMark as DefaultModuleIcon,
  SyncAlt as SyncAltIcon,
  TipsAndUpdates as LightbulbIcon,
} from "@mui/icons-material";

/** Module icons shared by dashboard group headings and public workspace rows. */
export const getModuleIcon = (moduleId: string): React.ReactNode => {
  const iconProps = { sx: { fontSize: 20 } };
  const moduleIcons: Record<string, React.ReactNode> = {
    bkg: <HandshakeIcon {...iconProps} data-testid="module-icon-bkg" />,
    ida: <LightbulbIcon {...iconProps} data-testid="module-icon-ida" />,
    meridian: (
      <DocumentIcon {...iconProps} data-testid="module-icon-meridian" />
    ),
    myvault: <SyncAltIcon {...iconProps} data-testid="module-icon-myvault" />,
  };

  return (
    moduleIcons[moduleId] || (
      <DefaultModuleIcon {...iconProps} data-testid="module-icon-default" />
    )
  );
};
